import * as React from "react"

const SvgComponent = (props) => (
  <svg width={24} height={24} fill="none" {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M3 7V5a2 2 0 0 1 2-2h2"/>
    <path d="M17 3h2a2 2 0 0 1 2 2v2"/>
    <path d="M21 17v2a2 2 0 0 1-2 2h-2"/>
    <path d="M7 21H5a2 2 0 0 1-2-2v-2"/>
    <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
    <path d="M9 9h.01"/>
    <path d="M15 9h.01"/>
  </svg>
)

export default SvgComponent
